import { Vue, Component } from 'vue-property-decorator';

import { LOADING_CONTENT } from '@/core/store/types/action-types';
import communicationClient from '@/core/api/communications-service';

import {
  CustomerCommunicationDetailDTO,
  CommunicationDocumentDTO,
} from '@/../client-generator/generated-clients/communications';
import documentsService from '@/core/api/documents-service';
import fileDownload from 'js-file-download';

@Component
export default class MessageDetail extends Vue {
  isLoading = false;

  resolvedDialogVisible = false;

  message: CustomerCommunicationDetailDTO | null = null;
  messageId: number | null = null;

  mounted() {
    if (this.$route.params.id) this.messageId = parseInt(this.$route.params.id, 10);
    this.fetchMessage();
  }

  async fetchMessage() {
    if (!this.messageId) return;

    this.$store.dispatch(LOADING_CONTENT, true);
    try {
      this.message = await communicationClient.myDetail(this.messageId);
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.$store.dispatch(LOADING_CONTENT, false);
    }
  }

  backToList() {
    this.$router.push({
      name: 'page-messages',
    });
  }

  async handleDownload(document: CommunicationDocumentDTO) {
    this.$store.dispatch(LOADING_CONTENT, true);

    try {
      const response = await documentsService.download(document.documentId as number, document.filename as string, '1');

      fileDownload(response.data, document.filename as string);
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 400:
          messageError = this.$t('employeeIdInvalid').toString();
          break;
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        case 404:
          messageError = this.$t('fileNotFound').toString();
          break;
        case 406:
          messageError = this.$t('fileNotAssociatedWithUser').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.$store.dispatch(LOADING_CONTENT, false);
    }
  }
}
